// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

// const InvoicingList = () => {
//     const [invoices, setInvoices] = useState([]);
//     const [selectedInvoice, setSelectedInvoice] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const invoicesPerPage = 10;
//     const invoiceRef = useRef();

//     // Fetch invoices
//     useEffect(() => {
//         const fetchInvoices = async () => {
//             try {
//                 const user = JSON.parse(sessionStorage.getItem("userData"));
//                 if (!user?.id) return;

//                 const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/invoices`, {
//                     params: { user_id: user.id }
//                 });
//                 setInvoices(res.data);
//             } catch (err) {
//                 console.error("Error fetching invoices:", err);
//             }
//         };
//         fetchInvoices();
//     }, []);

//     // PDF Generation
//     const handlePrintPDF = async () => {
//         if (!invoiceRef.current) return;
//         const canvas = await html2canvas(invoiceRef.current, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");
//         const width = pdf.internal.pageSize.getWidth();
//         const height = (canvas.height * width) / canvas.width;
//         pdf.addImage(imgData, "PNG", 0, 0, width, height);
//         pdf.save(`Invoice_${selectedInvoice.invoice_number}.pdf`);
//     };

//     // Pagination logic
//     const indexOfLastInvoice = currentPage * invoicesPerPage;
//     const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
//     const currentInvoices = invoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
//     const totalPages = Math.ceil(invoices.length / invoicesPerPage);

//     return (
//         <div style={{ fontFamily: 'Arial, sans-serif', minHeight: '100vh' }}>
//             <h2 style={{ fontSize: '15px', fontWeight: 'bold', textAlign: 'center', marginBottom: '20px' }}>📋 Invoice List</h2>

//             <div style={{ overflowX: 'auto', background: '#fff', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
//                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                     <thead>
//                         <tr style={{ background: '#f5f5f5' }}>
//                             {['Invoice #', 'Customer', 'Date', 'Total', 'Status', 'Action'].map((th, i) => (
//                                 <th key={i} style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>{th}</th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {currentInvoices.length > 0 ? currentInvoices.map(inv => {
//                             const items = typeof inv.items === "string" ? JSON.parse(inv.items || "[]") : inv.items || [];
//                             const subtotal = items.reduce((sum, it) => sum + (it.qty * it.rate), 0);
//                             const total = subtotal * 1.18;
//                             return (
//                                 <tr key={inv.id}>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{inv.invoice_number}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{inv.customer}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{new Date(inv.date).toLocaleDateString()}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>₹{total.toFixed(2)}</td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}><span style={{ color: '#fff', padding: '4px 10px', borderRadius: '4px', fontSize: '12px', minWidth: '60px', textAlign: 'center', display: 'inline-block', backgroundColor: inv.status === 'Paid' ? '#28a745' : inv.status === 'Sent' ? '#007bff' : '#6c757d' }}>{inv.status}</span></td>
//                                     <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>
//                                         <button style={{ background: '#007bff', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }} onClick={() => setSelectedInvoice({ ...inv, items })}>View</button>
//                                     </td>
//                                 </tr>
//                             )
//                         }) : (
//                             <tr><td colSpan="6" style={{ textAlign: 'center', padding: '12px' }}>No invoices found</td></tr>
//                         )}
//                     </tbody>
//                 </table>

//                 {/* Pagination Controls */}
//                 <div style={{ textAlign: 'center', marginTop: '15px' }}>
//                     <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ margin: '0 5px', padding: '6px 12px', border: '1px solid #007bff', borderRadius: '4px', backgroundColor: currentPage > 1 ? '#007bff' : '#e0e0e0', color: currentPage > 1 ? '#fff' : '#888', cursor: currentPage > 1 ? 'pointer' : 'not-allowed' }}>Previous</button>
//                     <span style={{ margin: '0 8px', fontSize: '12px', color: '#333' }}>Page {currentPage} of {totalPages || 1}</span>
//                     <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0} style={{ margin: '0 5px', padding: '6px 12px', border: '1px solid #007bff', borderRadius: '4px', backgroundColor: currentPage < totalPages ? '#007bff' : '#e0e0e0', color: currentPage < totalPages ? '#fff' : '#888', cursor: currentPage < totalPages ? 'pointer' : 'not-allowed' }} >Next</button>
//                 </div>

//             </div>

//             {/* Invoice Modal */}
//             {selectedInvoice && (
//                 <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
//                     <div ref={invoiceRef} style={{ background: '#fff', padding: '25px 30px', borderRadius: '10px', width: '750px', maxHeight: '90vh', overflowY: 'auto' }}>
//                         <h3 style={{ textAlign: 'center', borderBottom: '2px solid #007bff', paddingBottom: '12px', marginBottom: '25px', fontSize: '20px' }}>Invoice #{selectedInvoice.invoice_number}</h3>

//                         {/* Customer Info Grid */}
//                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '10px', marginBottom: '20px' }}>
//                             <div style={{ padding: '8px 10px', background: '#f1f1f1', borderRadius: '5px', textAlign: 'left' }}><strong>Customer:</strong> {selectedInvoice.customer}</div>
//                             <div style={{ padding: '8px 10px', background: '#f1f1f1', borderRadius: '5px', textAlign: 'left' }}><strong>Email:</strong> {selectedInvoice.email}</div>
//                             <div style={{ padding: '8px 10px', background: '#f1f1f1', borderRadius: '5px', textAlign: 'left' }}><strong>Phone:</strong> {selectedInvoice.phone}</div>
//                             <div style={{ padding: '8px 10px', background: '#f1f1f1', borderRadius: '5px', textAlign: 'left' }}><strong>GSTIN:</strong> {selectedInvoice.gstin}</div>
//                         </div>

//                         {/* Items Table */}
//                         <h4 style={{ marginTop: '20px' }}>Items:</h4>
//                         <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
//                             <thead>
//                                 <tr>
//                                     {['Description', 'Qty', 'Rate', 'Amount'].map((th, i) => (
//                                         <th key={i} style={{ textAlign: 'left', padding: '12px 8px', borderBottom: '1px solid #ddd', color: '#555' }}>{th}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {(selectedInvoice.items || []).map((item, idx) => (
//                                     <tr key={idx}>
//                                         <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{item.description}</td>
//                                         <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>{item.qty}</td>
//                                         <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>₹{item.rate}</td>
//                                         <td style={{ padding: '10px 8px', borderBottom: '1px solid #eee', color: '#444' }}>₹{(item.qty * item.rate).toFixed(2)}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>

//                         {/* Totals */}
//                         <div style={{ marginTop: '15px', textAlign: 'right', borderTop: '2px solid #007bff', paddingTop: '10px' }}>
//                             <p><strong>Subtotal:</strong> ₹{(selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0).toFixed(2)}</p>
//                             <p><strong>GST (18%):</strong> ₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 0.18).toFixed(2)}</p>
//                             <p><strong>Total:</strong> ₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 1.18).toFixed(2)}</p>
//                         </div>

//                         {/* Modal Buttons */}
//                         <div style={{ marginTop: '20px', textAlign: 'right' }}>
//                             <button onClick={handlePrintPDF} style={{ background: '#28a745', color: '#fff', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' }}>🖨️ Print / PDF</button>
//                             <button onClick={() => setSelectedInvoice(null)} style={{ background: '#dc3545', color: '#fff', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>✖ Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default InvoicingList;


// import React, { useState, useEffect } from 'react';
// import { 
//   Plus, Search, Filter, Eye, Download, Send, Edit2, X, 
//   FileText, Calendar, ChevronLeft, ChevronRight 
// } from 'lucide-react';

// // Mock Invoice Data
// const invoiceData = [
//   { id: 'INV-001', customer: 'Acme Corp', issueDate: '2024-12-20', dueDate: '2025-01-20', amount: '$12,500', status: 'Paid', paymentDate: '2024-12-25' },
//   { id: 'INV-002', customer: 'TechStart Inc', issueDate: '2024-12-21', dueDate: '2025-01-21', amount: '$8,900', status: 'Pending', paymentDate: '-' },
//   { id: 'INV-003', customer: 'Global Inc', issueDate: '2024-12-22', dueDate: '2025-01-22', amount: '$15,200', status: 'Paid', paymentDate: '2024-12-28' },
//   { id: 'INV-004', customer: 'Digital Pro', issueDate: '2024-12-23', dueDate: '2025-01-23', amount: '$6,750', status: 'Overdue', paymentDate: '-' },
//   { id: 'INV-005', customer: 'Creative Agency', issueDate: '2024-12-24', dueDate: '2025-01-24', amount: '$22,100', status: 'Pending', paymentDate: '-' },
// ];

// const InvoicingList = ({ onCreateNew, onEditInvoice }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedInvoice, setSelectedInvoice] = useState(null);
  
//   // Pagination State Variables
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 3;

//   // Track window width to implement clean inline responsive breakdowns (md = 768px)
//   const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const isMobile = windowWidth < 768;

//   const filteredInvoices = invoiceData.filter(invoice => 
//     invoice.customer.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     invoice.id.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Pagination Logic Computations
//   const totalItems = filteredInvoices.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentInvoices = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const getStatusStyle = (status) => {
//     const baseStyle = {
//       display: 'inline-block',
//       padding: '2px 10px',
//       borderRadius: '9999px',
//       fontSize: '12px',
//       fontWeight: '500'
//     };
//     switch (status) {
//       case 'Paid': 
//         return { ...baseStyle, backgroundColor: '#dcfce7', color: '#15803d' };
//       case 'Pending': 
//         return { ...baseStyle, backgroundColor: '#ffedd5', color: '#c2410c' };
//       case 'Overdue': 
//         return { ...baseStyle, backgroundColor: '#fee2e2', color: '#b91c1c' };
//       default:
//         return baseStyle;
//     }
//   };

//   return (
//     <div style={{
//       padding: isMobile ? '16px' : '32px',
//       maxWidth: '1280px',
//       marginLeft: 'auto',
//       marginRight: 'auto',
//       position: 'relative',
//       minHeight: '100vh',
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//       backgroundColor: '#f8fafc',
//       color: '#334155',
//       boxSizing: 'border-box'
//     }}>
      
//       {/* Title Header Block */}
//       <div style={{
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         alignItems: isMobile ? 'flex-start' : 'center',
//         justifyContent: 'between',
//         justifyContent: 'space-between',
//         gap: '16px',
//         marginBottom: '24px'
//       }}>
//         <div>
//           <h1 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px 0' }}>Invoices</h1>
//           <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Manage customer invoices and parameters</p>
//         </div>
//         <button 
//           onClick={onCreateNew} 
//           style={{
//             display: 'flex',
//             itemsCenter: 'center',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '8px',
//             padding: '10px 20px',
//             backgroundColor: '#2563eb',
//             color: '#ffffff',
//             borderRadius: '12px',
//             border: 'none',
//             fontSize: '14px',
//             fontWeight: '500',
//             cursor: 'pointer',
//             boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//             width: isMobile ? '100%' : 'auto',
//             transition: 'background-color 0.2s'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//         >
//           <Plus style={{ width: '18px', height: '18px' }} />
//           Create Invoice
//         </button>
//       </div>

//       {/* Numerical Metrics Cards Grid */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//         gap: '16px',
//         marginBottom: '24px'
//       }}>
//         {[
//           { label: 'Total Invoices', value: '287', color: '#0f172a' },
//           { label: 'Paid', value: '234', color: '#16a34a' },
//           { label: 'Pending', value: '42', color: '#ea580c' },
//           { label: 'Overdue', value: '11', color: '#dc2626' }
//         ].map((stat, idx) => (
//           <div key={idx} style={{
//             backgroundColor: '#ffffff',
//             border: '1px solid #e2e8f0',
//             borderRadius: '16px',
//             padding: '16px',
//             boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.01)'
//           }}>
//             <p style={{ color: '#64748b', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', trackingLetter: '0.05em', margin: '0 0 4px 0' }}>{stat.label}</p>
//             <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: stat.color, margin: 0 }}>{stat.value}</h3>
//           </div>
//         ))}
//       </div>

//       {/* Query Search Actions Controls */}
//       <div style={{
//         backgroundColor: '#ffffff',
//         border: '1px solid #e2e8f0',
//         borderRadius: '16px',
//         padding: '16px',
//         marginBottom: '24px',
//         boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.01)'
//       }}>
//         <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '12px' }}>
//           <div style={{ flex: 1, position: 'relative' }}>
//             <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#94a3b8' }} />
//             <input
//               type="text"
//               placeholder="Search by ID or customer..."
//               value={searchTerm}
//               onChange={(e) => {
//                 setSearchTerm(e.target.value);
//                 setCurrentPage(1);
//               }}
//               style={{
//                 width: '100%',
//                 boxSizing: 'border-box',
//                 paddingLeft: '36px',
//                 paddingRight: '16px',
//                 paddingTop: '10px',
//                 paddingBottom: '10px',
//                 backgroundColor: '#f8fafc',
//                 color: '#1e293b',
//                 borderRadius: '12px',
//                 border: '1px solid #e2e8f0',
//                 outline: 'none',
//                 fontSize: '14px',
//                 transition: 'all 0.2s'
//               }}
//               onFocus={(e) => {
//                 e.currentTarget.style.backgroundColor = '#ffffff';
//                 e.currentTarget.style.borderColor = '#2563eb';
//                 e.currentTarget.style.boxShadow = '0 0 0 1px #2563eb';
//               }}
//               onBlur={(e) => {
//                 e.currentTarget.style.backgroundColor = '#f8fafc';
//                 e.currentTarget.style.borderColor = '#e2e8f0';
//                 e.currentTarget.style.boxShadow = 'none';
//               }}
//             />
//           </div>
//           <button style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '8px',
//             padding: '10px 16px',
//             border: '1px solid #e2e8f0',
//             color: '#475569',
//             fontSize: '14px',
//             fontWeight: '500',
//             borderRadius: '12px',
//             backgroundColor: '#ffffff',
//             cursor: 'pointer',
//             transition: 'background-color 0.2s'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
//           >
//             <Filter style={{ width: '16px', height: '16px' }} />
//             Filter
//           </button>
//         </div>
//       </div>

//       {/* Table Content Block */}
//       <div style={{
//         backgroundColor: '#ffffff',
//         border: '1px solid #e2e8f0',
//         borderRadius: '16px',
//         overflow: 'hidden',
//         boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.01)',
//         display: 'flex',
//         flexDirection: 'column'
//       }}>
        
//         {/* Desktop Layout View */}
//         {!isMobile && (
//           <div>
//             {/* Header Row */}
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
//               gap: '8px',
//               backgroundColor: 'rgba(248, 250, 252, 0.7)',
//               borderBottom: '1px solid #e2e8f0',
//               padding: '12px 24px',
//               fontSize: '12px',
//               fontWeight: '700',
//               textTransform: 'uppercase',
//               letterSpacing: '0.05em',
//               color: '#64748b'
//             }}>
//               <div style={{ gridColumn: 'span 2' }}>Invoice ID</div>
//               <div style={{ gridColumn: 'span 3' }}>Customer</div>
//               <div style={{ gridColumn: 'span 2' }}>Dates</div>
//               <div style={{ gridColumn: 'span 2', textAlign: 'right', paddingRight: '16px' }}>Amount</div>
//               <div style={{ gridColumn: 'span 1', textAlign: 'center' }}>Status</div>
//               <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>Actions</div>
//             </div>
            
//             {/* Body Rows */}
//             <div style={{ display: 'flex', flexDirection: 'column' }}>
//               {currentInvoices.map((invoice) => (
//                 <div 
//                   key={invoice.id} 
//                   style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
//                     gap: '8px',
//                     padding: '16px 24px',
//                     alignItems: 'center',
//                     fontSize: '14px',
//                     borderBottom: '1px solid #f1f5f9',
//                     color: '#334155',
//                     transition: 'background-color 0.2s'
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
//                 >
//                   <div style={{ gridColumn: 'span 2', fontWeight: '600', color: '#0f172a' }}>{invoice.id}</div>
//                   <div style={{ gridColumn: 'span 3', fontWeight: '500', color: '#1e293b' }}>{invoice.customer}</div>
//                   <div style={{ gridColumn: 'span 2', fontSize: '12px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
//                     <div style={{ color: '#64748b' }}><span style={{ fontWeight: '500' }}>Issued:</span> {invoice.issueDate}</div>
//                     <div style={{ color: '#94a3b8' }}><span style={{ fontWeight: '500' }}>Due:</span> {invoice.dueDate}</div>
//                   </div>
//                   <div style={{ gridColumn: 'span 2', textAlign: 'right', paddingRight: '16px', fontWeight: '600', color: '#0f172a' }}>{invoice.amount}</div>
//                   <div style={{ gridColumn: 'span 1', textAlign: 'center' }}>
//                     <span style={getStatusStyle(invoice.status)}>
//                       {invoice.status}
//                     </span>
//                   </div>
//                   <div style={{ gridColumn: 'span 2', display: 'flex', justifyContent: 'flex-end', gap: '4px' }}>
//                     <button onClick={() => setSelectedInvoice(invoice)} style={{ padding: '6px', border: 'none', background: 'none', color: '#64748b', borderRadius: '8px', cursor: 'pointer' }} title="View Details">
//                       <Eye style={{ width: '16px', height: '16px' }} />
//                     </button>
//                     <button onClick={() => onEditInvoice?.(invoice.id)} style={{ padding: '6px', border: 'none', background: 'none', color: '#64748b', borderRadius: '8px', cursor: 'pointer' }} title="Edit Invoicing Block">
//                       <Edit2 style={{ width: '16px', height: '16px' }} />
//                     </button>
//                     <button style={{ padding: '6px', border: 'none', background: 'none', color: '#64748b', borderRadius: '8px', cursor: 'pointer' }} title="Download Asset">
//                       <Download style={{ width: '16px', height: '16px' }} />
//                     </button>
//                     <button style={{ padding: '6px', border: 'none', background: 'none', color: '#64748b', borderRadius: '8px', cursor: 'pointer' }} title="Dispatch Mail">
//                       <Send style={{ width: '16px', height: '16px' }} />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Mobile Layout View */}
//         {isMobile && (
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             {currentInvoices.map((invoice) => (
//               <div key={invoice.id} style={{ padding: '16px', borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                   <span style={{ fontSize: '12px', fontWeight: '700', color: '#2563eb', backgroundColor: '#eff6ff', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace' }}>{invoice.id}</span>
//                   <span style={getStatusStyle(invoice.status)}>
//                     {invoice.status}
//                   </span>
//                 </div>
//                 <div>
//                   <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', margin: '0 0 4px 0' }}>{invoice.customer}</h4>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
//                     <p style={{ fontSize: '12px', color: '#94a3b8', margin: 0 }}>Due {invoice.dueDate}</p>
//                     <p style={{ fontSize: '16px', fontWeight: '700', color: '#0f172a', margin: 0 }}>{invoice.amount}</p>
//                   </div>
//                 </div>
//                 <div style={{ paddingTop: '8px', borderTop: '1px solid #f8fafc', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
//                   <button onClick={() => setSelectedInvoice(invoice)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '12px', color: '#475569', backgroundColor: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
//                     <Eye style={{ width: '14px', height: '14px' }} /> View
//                   </button>
//                   <button onClick={() => onEditInvoice?.(invoice.id)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '12px', color: '#475569', backgroundColor: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
//                     <Edit2 style={{ width: '14px', height: '14px' }} /> Edit
//                   </button>
//                   <button style={{ padding: '6px', color: '#64748b', backgroundColor: 'transparent', border: 'none', borderRadius: '8px' }}>
//                     <Download style={{ width: '16px', height: '16px' }} />
//                   </button>
//                   <button style={{ padding: '6px', color: '#64748b', backgroundColor: 'transparent', border: 'none', borderRadius: '8px' }}>
//                     <Send style={{ width: '16px', height: '16px' }} />
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Pagination Footer Container Block */}
//         <div style={{
//           backgroundColor: 'rgba(248, 250, 252, 0.6)',
//           padding: '14px 16px',
//           borderTop: '1px solid #e2e8f0',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between'
//         }}>
//           {isMobile ? (
//             <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between' }}>
//               <button
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: '8px 16px',
//                   border: '1px solid #e2e8f0',
//                   fontSize: '12px',
//                   fontWeight: '600',
//                   borderRadius: '12px',
//                   color: '#475569',
//                   backgroundColor: '#ffffff',
//                   opacity: currentPage === 1 ? 0.4 : 1,
//                   cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Previous
//               </button>
//               <button
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: '8px 16px',
//                   border: '1px solid #e2e8f0',
//                   fontSize: '12px',
//                   fontWeight: '600',
//                   borderRadius: '12px',
//                   color: '#475569',
//                   backgroundColor: '#ffffff',
//                   opacity: currentPage === totalPages ? 0.4 : 1,
//                   cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           ) : (
//             <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//               <div>
//                 <p style={{ fontSize: '12px', color: '#64748b', margin: 0 }}>
//                   Showing <span style={{ fontWeight: '600', color: '#334155' }}>{totalItems === 0 ? 0 : indexOfFirstItem + 1}</span> to{' '}
//                   <span style={{ fontWeight: '600', color: '#334155' }}>
//                     {indexOfLastItem > totalItems ? totalItems : indexOfLastItem}
//                   </span>{' '}
//                   of <span style={{ fontWeight: '600', color: '#334155' }}>{totalItems}</span> invoices
//                 </p>
//               </div>
              
//               <div>
//                 <nav style={{ display: 'inline-flex', borderRadius: '12px', gap: '4px' }} aria-label="Pagination">
//                   <button
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                     style={{
//                       padding: '8px',
//                       borderRadius: '12px',
//                       border: '1px solid #e2e8f0',
//                       backgroundColor: '#ffffff',
//                       color: '#64748b',
//                       opacity: currentPage === 1 ? 0.4 : 1,
//                       cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}
//                   >
//                     <ChevronLeft style={{ width: '16px', height: '16px' }} />
//                   </button>
                  
//                   {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//                     <button
//                       key={page}
//                       onClick={() => handlePageChange(page)}
//                       style={{
//                         padding: '6px 14px',
//                         borderRadius: '12px',
//                         border: '1px solid',
//                         fontSize: '12px',
//                         fontWeight: '600',
//                         cursor: 'pointer',
//                         borderColor: currentPage === page ? '#2563eb' : '#e2e8f0',
//                         backgroundColor: currentPage === page ? '#2563eb' : '#ffffff',
//                         color: currentPage === page ? '#ffffff' : '#475569',
//                         boxShadow: currentPage === page ? '0 1px 2px 0 rgba(0, 0, 0, 0.05)' : 'none'
//                       }}
//                     >
//                       {page}
//                     </button>
//                   ))}

//                   <button
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                     style={{
//                       padding: '8px',
//                       borderRadius: '12px',
//                       border: '1px solid #e2e8f0',
//                       backgroundColor: '#ffffff',
//                       color: '#64748b',
//                       opacity: currentPage === totalPages ? 0.4 : 1,
//                       cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
//                       display: 'flex',
//                       alignItems: 'center'
//                     }}
//                   >
//                     <ChevronRight style={{ width: '16px', height: '16px' }} />
//                   </button>
//                 </nav>
//               </div>
//             </div>
//           )}
//         </div>

//       </div>

//       {/* Sliding Overlay Drawer Component Modal Layout Panel */}
//       {selectedInvoice && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           zIndex: 50,
//           display: 'flex',
//           justifyContent: 'flex-end',
//           backgroundColor: 'rgba(15, 23, 42, 0.4)',
//           backdropFilter: 'blur(4px)',
//           transition: 'opacity 0.3s',
//           marginTop:70
//         }}>
//           <div style={{
//             width: '100%',
//             maxWidth: '448px',
//             backgroundColor: '#ffffff',
//             height: '100%',
//             boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
//             display: 'flex',
//             flexDirection: 'column',
//             padding: '24px',
//             boxSizing: 'border-box',
//             gap: '24px',
//             position: 'relative'
//           }}>
            
//             {/* Drawer Header Block */}
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #f1f5f9', paddingBottom: '16px' }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                 <div style={{ padding: '8px', backgroundColor: '#eff6ff', borderRadius: '12px', color: '#2563eb', display: 'flex' }}>
//                   <FileText style={{ width: '20px', height: '20px' }} />
//                 </div>
//                 <div>
//                   <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a', margin: 0 }}>{selectedInvoice.id}</h3>
//                   <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>Invoice Parameter Logs</p>
//                 </div>
//               </div>
//               <button 
//                 onClick={() => setSelectedInvoice(null)}
//                 style={{ padding: '6px', color: '#94a3b8', backgroundColor: 'transparent', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
//               >
//                 <X style={{ width: '20px', height: '20px' }} />
//               </button>
//             </div>

//             {/* Modal Drawer Node Metrics Rows List layout */}
//             <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px', overflowY: 'auto' }}>
//               <div style={{ backgroundColor: '#f8fafc', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                 <span style={{ fontSize: '12px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Client Ledger</span>
//                 <h4 style={{ fontSize: '16px', fontWeight: '700', color: '#0f172a', margin: 0 }}>{selectedInvoice.customer}</h4>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
//                 <div style={{ border: '1px solid #f1f5f9', padding: '14px', borderRadius: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                   <span style={{ fontSize: '11px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase' }}>Issue Date</span>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: '600', color: '#475569' }}>
//                     <Calendar style={{ width: '14px', height: '14px', color: '#94a3b8' }} />
//                     {selectedInvoice.issueDate}
//                   </div>
//                 </div>
//                 <div style={{ border: '1px solid #f1f5f9', padding: '14px', borderRadius: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
//                   <span style={{ fontSize: '11px', fontWeight: '500', color: '#94a3b8', textTransform: 'uppercase' }}>Due Date</span>
//                   <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: '600', color: '#475569' }}>
//                     <Calendar style={{ width: '14px', height: '14px', color: '#94a3b8' }} />
//                     {selectedInvoice.dueDate}
//                   </div>
//                 </div>
//               </div>

//               <div style={{ border: '1px solid #f1f5f9', borderRadius: '12px', display: 'flex', flexDirection: 'column' }}>
//                 <div style={{ padding: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', borderBottom: '1px solid #f1f5f9' }}>
//                   <span style={{ color: '#94a3b8', fontWeight: '500' }}>Total Ledger Valuation</span>
//                   <span style={{ fontSize: '18px', fontWeight: '700', color: '#2563eb' }}>{selectedInvoice.amount}</span>
//                 </div>
//                 <div style={{ padding: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', borderBottom: '1px solid #f1f5f9' }}>
//                   <span style={{ color: '#94a3b8', fontWeight: '500' }}>Payment Execution Stamp</span>
//                   <span style={{ fontWeight: '500', color: '#475569' }}>{selectedInvoice.paymentDate}</span>
//                 </div>
//                 <div style={{ padding: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                   <span style={{ color: '#94a3b8', fontWeight: '500' }}>Lifecycle Tracking Status</span>
//                   <span style={getStatusStyle(selectedInvoice.status)}>
//                     {selectedInvoice.status}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Actions Panel Footer Container Block */}
//             <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '16px', display: 'flex', gap: '12px' }}>
//               <button 
//                 onClick={() => {
//                   if(onEditInvoice) onEditInvoice(selectedInvoice.id);
//                   setSelectedInvoice(null);
//                 }}
//                 style={{
//                   flex: 1,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: '8px',
//                   padding: '10px 0',
//                   backgroundColor: '#f1f5f9',
//                   color: '#334155',
//                   fontSize: '14px',
//                   fontWeight: '600',
//                   borderRadius: '12px',
//                   border: 'none',
//                   cursor: 'pointer',
//                   transition: 'background-color 0.2s'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e2e8f0'}
//                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f1f5f9'}
//               >
//                 <Edit2 style={{ width: '16px', height: '16px' }} /> Edit Configuration
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
// export default InvoicingList;


// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

// const InvoicingList = () => {
//     const [invoices, setInvoices] = useState([]);
//     const [selectedInvoice, setSelectedInvoice] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const invoicesPerPage = 10;
//     const invoiceRef = useRef();

//     // Fetch invoices
//     useEffect(() => {
//         const fetchInvoices = async () => {
//             try {
//                 const user = JSON.parse(sessionStorage.getItem("userData"));
//                 if (!user?.id) return;

//                 const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/invoices`, {
//                     params: { user_id: user.id }
//                 });
//                 setInvoices(res.data);
//             } catch (err) {
//                 console.error("Error fetching invoices:", err);
//             }
//         };
//         fetchInvoices();
//     }, []);

//     // PDF Generation
//     const handlePrintPDF = async () => {
//         if (!invoiceRef.current) return;
//         const canvas = await html2canvas(invoiceRef.current, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");
//         const width = pdf.internal.pageSize.getWidth();
//         const height = (canvas.height * width) / canvas.width;
//         pdf.addImage(imgData, "PNG", 0, 0, width, height);
//         pdf.save(`Invoice_${selectedInvoice.invoice_number}.pdf`);
//     };

//     // Pagination logic
//     const indexOfLastInvoice = currentPage * invoicesPerPage;
//     const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
//     const currentInvoices = invoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
//     const totalPages = Math.ceil(invoices.length / invoicesPerPage);

//     // Responsive helper values calculated safely
//     const totalCount = invoices.length;
//     const paidCount = invoices.filter(i => i.status === 'Paid').length;
//     const sentCount = invoices.filter(i => i.status === 'Sent').length;
//     const draftCount = totalCount - paidCount - sentCount;

//     const getStatusStyle = (status) => {
//         const baseStyle = {
//             display: 'inline-block',
//             padding: '4px 12px',
//             borderRadius: '9999px',
//             fontSize: '12px',
//             fontWeight: '600',
//             textAlign: 'center',
//             minWidth: '70px'
//         };
//         switch (status) {
//             case 'Paid': 
//                 return { ...baseStyle, backgroundColor: '#dcfce7', color: '#15803d' };
//             case 'Sent': 
//                 return { ...baseStyle, backgroundColor: '#eff6ff', color: '#1d4ed8' };
//             default:
//                 return { ...baseStyle, backgroundColor: '#f1f5f9', color: '#475569' };
//         }
//     };

//     return (
//         <div style={{
//             padding: '24px',
//             maxWidth: '1280px',
//             marginLeft: 'auto',
//             marginRight: 'auto',
//             position: 'relative',
//             minHeight: '100vh',
//             fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//             backgroundColor: '#f8fafc',
//             color: '#334155',
//             boxSizing: 'border-box'
//         }}>
            
//             {/* Title Header Block */}
//             <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between',
//                 gap: '16px',
//                 marginBottom: '24px'
//             }}>
//                 <div>
//                     <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px 0' }}>📋 Invoices</h1>
//                     <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Manage customer invoices and parameters</p>
//                 </div>
//             </div>

//             {/* Numerical Metrics Cards Grid */}
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: 'repeat(4, 1fr)',
//                 gap: '16px',
//                 marginBottom: '24px'
//             }}>
//                 {[
//                     { label: 'Total Invoices', value: totalCount, color: '#0f172a' },
//                     { label: 'Paid', value: paidCount, color: '#16a34a' },
//                     { label: 'Sent', value: sentCount, color: '#2563eb' },
//                     { label: 'Pending / Draft', value: draftCount, color: '#64748b' }
//                 ].map((stat, idx) => (
//                     <div key={idx} style={{
//                         backgroundColor: '#ffffff',
//                         border: '1px solid #e2e8f0',
//                         borderRadius: '16px',
//                         padding: '16px',
//                         boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)'
//                     }}>
//                         <p style={{ color: '#64748b', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>{stat.label}</p>
//                         <h3 style={{ fontSize: '24px', fontWeight: '700', color: stat.color, margin: 0 }}>{stat.value}</h3>
//                     </div>
//                 ))}
//             </div>

//             {/* Table Layout View Module Container */}
//             <div style={{
//                 backgroundColor: '#ffffff',
//                 border: '1px solid #e2e8f0',
//                 borderRadius: '16px',
//                 overflow: 'hidden',
//                 boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)',
//                 display: 'flex',
//                 flexDirection: 'column'
//             }}>
//                 <div style={{ overflowX: 'auto' }}>
//                     <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
//                         <thead>
//                             <tr style={{
//                                 backgroundColor: 'rgba(248, 250, 252, 0.7)',
//                                 borderBottom: '1px solid #e2e8f0',
//                                 fontSize: '12px',
//                                 fontWeight: '700',
//                                 textTransform: 'uppercase',
//                                 letterSpacing: '0.05em',
//                                 color: '#64748b'
//                             }}>
//                                 <th style={{ padding: '14px 24px' }}>Invoice ID</th>
//                                 <th style={{ padding: '14px 24px' }}>Customer</th>
//                                 <th style={{ padding: '14px 24px' }}>Date</th>
//                                 <th style={{ padding: '14px 24px', textAlign: 'right' }}>Total Amount</th>
//                                 <th style={{ padding: '14px 24px', textAlign: 'center' }}>Status</th>
//                                 <th style={{ padding: '14px 24px', textAlign: 'right' }}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentInvoices.length > 0 ? currentInvoices.map(inv => {
//                                 const items = typeof inv.items === "string" ? JSON.parse(inv.items || "[]") : inv.items || [];
//                                 const subtotal = items.reduce((sum, it) => sum + (it.qty * it.rate), 0);
//                                 const total = subtotal * 1.18;
                                
//                                 return (
//                                     <tr 
//                                         key={inv.id}
//                                         style={{
//                                             fontSize: '14px',
//                                             borderBottom: '1px solid #f1f5f9',
//                                             color: '#334155',
//                                             transition: 'background-color 0.2s'
//                                         }}
//                                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
//                                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
//                                     >
//                                         <td style={{ padding: '16px 24px', fontWeight: '600', color: '#0f172a' }}>{inv.invoice_number}</td>
//                                         <td style={{ padding: '16px 24px', fontWeight: '500', color: '#1e293b' }}>{inv.customer}</td>
//                                         <td style={{ padding: '16px 24px', color: '#64748b' }}>{new Date(inv.date).toLocaleDateString()}</td>
//                                         <td style={{ padding: '16px 24px', textAlign: 'right', fontWeight: '600', color: '#0f172a' }}>₹{total.toFixed(2)}</td>
//                                         <td style={{ padding: '16px 24px', textAlign: 'center' }}>
//                                             <span style={getStatusStyle(inv.status)}>{inv.status}</span>
//                                         </td>
//                                         <td style={{ padding: '16px 24px', textAlign: 'right' }}>
//                                             <button 
//                                                 onClick={() => setSelectedInvoice({ ...inv, items })}
//                                                 style={{ 
//                                                     background: '#2563eb', 
//                                                     color: '#fff', 
//                                                     border: 'none', 
//                                                     padding: '6px 14px', 
//                                                     borderRadius: '8px', 
//                                                     cursor: 'pointer',
//                                                     fontSize: '13px',
//                                                     fontWeight: '500',
//                                                     boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
//                                                     transition: 'background-color 0.2s'
//                                                 }}
//                                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
//                                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//                                             >
//                                                 View
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 );
//                             }) : (
//                                 <tr>
//                                     <td colSpan="6" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '14px' }}>
//                                         No invoices found
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Pagination Footer Container Block */}
//                 <div style={{
//                     backgroundColor: 'rgba(248, 250, 252, 0.6)',
//                     padding: '14px 24px',
//                     borderTop: '1px solid #e2e8f0',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between'
//                 }}>
//                     <div>
//                         <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
//                             Showing <span style={{ fontWeight: '600', color: '#334155' }}>{totalCount === 0 ? 0 : indexOfFirstInvoice + 1}</span> to{' '}
//                             <span style={{ fontWeight: '600', color: '#334155' }}>
//                                 {indexOfLastInvoice > totalCount ? totalCount : indexOfLastInvoice}
//                             </span>{' '}
//                             of <span style={{ fontWeight: '600', color: '#334155' }}>{totalCount}</span> invoices
//                         </p>
//                     </div>
                    
//                     <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
//                         <button
//                             onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                             disabled={currentPage === 1}
//                             style={{
//                                 padding: '8px 14px',
//                                 border: '1px solid #e2e8f0',
//                                 fontSize: '13px',
//                                 fontWeight: '600',
//                                 borderRadius: '10px',
//                                 color: currentPage === 1 ? '#94a3b8' : '#475569',
//                                 backgroundColor: '#ffffff',
//                                 cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
//                                 transition: 'all 0.2s'
//                             }}
//                         >
//                             Previous
//                         </button>
                        
//                         <span style={{ fontSize: '13px', color: '#475569', padding: '0 8px' }}>
//                             Page <strong>{currentPage}</strong> of {totalPages || 1}
//                         </span>

//                         <button
//                             onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                             disabled={currentPage === totalPages || totalPages === 0}
//                             style={{
//                                 padding: '8px 14px',
//                                 border: '1px solid #e2e8f0',
//                                 fontSize: '13px',
//                                 fontWeight: '600',
//                                 borderRadius: '10px',
//                                 color: (currentPage === totalPages || totalPages === 0) ? '#94a3b8' : '#475569',
//                                 backgroundColor: '#ffffff',
//                                 cursor: (currentPage === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer',
//                                 transition: 'all 0.2s'
//                             }}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Sliding Overlay Drawer Component Modal Layout Panel */}
//             {selectedInvoice && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     zIndex: 1000,
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     backgroundColor: 'rgba(15, 23, 42, 0.4)',
//                     backdropFilter: 'blur(4px)'
//                 }}>
//                     <div style={{
//                         width: '100%',
//                         maxWidth: '520px',
//                         backgroundColor: '#ffffff',
//                         height: '100%',
//                         boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         padding: '24px',
//                         boxSizing: 'border-box',
//                         gap: '24px',
//                         position: 'relative'
//                     }}>
                        
//                         {/* Interactive Container target for html2canvas extraction wrapper */}
//                         <div ref={invoiceRef} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '20px', overflowY: 'auto', paddingRight: '4px' }}>
                            
//                             {/* Drawer Header Block */}
//                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid #2563eb', paddingBottom: '16px' }}>
//                                 <div>
//                                     <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a', margin: 0 }}>Invoice #{selectedInvoice.invoice_number}</h3>
//                                     <p style={{ color: '#94a3b8', fontSize: '12px', margin: '4px 0 0 0' }}>Invoice Parameter Details</p>
//                                 </div>
//                             </div>

//                             {/* Customer Info Grid */}
//                             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
//                                 <div style={{ border: '1px solid #f1f5f9', padding: '12px', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
//                                     <span style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>Customer</span>
//                                     <div style={{ fontSize: '14px', fontWeight: '600', color: '#334155' }}>{selectedInvoice.customer}</div>
//                                 </div>
//                                 <div style={{ border: '1px solid #f1f5f9', padding: '12px', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
//                                     <span style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>Email</span>
//                                     <div style={{ fontSize: '14px', fontWeight: '600', color: '#334155', wordBreak: 'break-all' }}>{selectedInvoice.email}</div>
//                                 </div>
//                                 <div style={{ border: '1px solid #f1f5f9', padding: '12px', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
//                                     <span style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>Phone</span>
//                                     <div style={{ fontSize: '14px', fontWeight: '600', color: '#334155' }}>{selectedInvoice.phone}</div>
//                                 </div>
//                                 <div style={{ border: '1px solid #f1f5f9', padding: '12px', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
//                                     <span style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', display: 'block', marginBottom: '2px' }}>GSTIN</span>
//                                     <div style={{ fontSize: '14px', fontWeight: '600', color: '#334155' }}>{selectedInvoice.gstin}</div>
//                                 </div>
//                             </div>

//                             {/* Items Table */}
//                             <div>
//                                 <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#475569', margin: '10px 0' }}>Line Items:</h4>
//                                 <div style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' }}>
//                                     <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
//                                         <thead>
//                                             <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#64748b', fontWeight: '600' }}>
//                                                 <th style={{ padding: '10px 12px' }}>Description</th>
//                                                 <th style={{ padding: '10px 12px', textAlign: 'center' }}>Qty</th>
//                                                 <th style={{ padding: '10px 12px', textAlign: 'right' }}>Rate</th>
//                                                 <th style={{ padding: '10px 12px', textAlign: 'right' }}>Amount</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {(selectedInvoice.items || []).map((item, idx) => (
//                                                 <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', color: '#475569' }}>
//                                                     <td style={{ padding: '10px 12px' }}>{item.description}</td>
//                                                     <td style={{ padding: '10px 12px', textAlign: 'center' }}>{item.qty}</td>
//                                                     <td style={{ padding: '10px 12px', textAlign: 'right' }}>₹{parseFloat(item.rate).toFixed(2)}</td>
//                                                     <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: '500' }}>₹{(item.qty * item.rate).toFixed(2)}</td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>

//                             {/* Valuation Computations Layout Block */}
//                             <div style={{ 
//                                 border: '1px solid #e2e8f0', 
//                                 borderRadius: '12px', 
//                                 display: 'flex', 
//                                 flexDirection: 'column', 
//                                 backgroundColor: '#f8fafc',
//                                 padding: '4px 0' 
//                             }}>
//                                 <div style={{ padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px' }}>
//                                     <span style={{ color: '#64748b', fontWeight: '500' }}>Subtotal Valuation</span>
//                                     <span style={{ fontWeight: '600', color: '#334155' }}>₹{(selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0).toFixed(2)}</span>
//                                 </div>
//                                 <div style={{ padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
//                                     <span style={{ color: '#64748b', fontWeight: '500' }}>GST Standard Levy (18%)</span>
//                                     <span style={{ fontWeight: '600', color: '#334155' }}>₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 0.18).toFixed(2)}</span>
//                                 </div>
//                                 <div style={{ padding: '14px 16px 10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
//                                     <span style={{ color: '#0f172a', fontWeight: '700' }}>Total Document Valuation</span>
//                                     <span style={{ fontSize: '18px', fontWeight: '700', color: '#2563eb' }}>₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 1.18).toFixed(2)}</span>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Control Actions Footer Layout */}
//                         <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '16px', display: 'flex', gap: '12px' }}>
//                             <button 
//                                 onClick={handlePrintPDF} 
//                                 style={{ 
//                                     flex: 1,
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     gap: '8px',
//                                     padding: '10px 0',
//                                     backgroundColor: '#16a34a', 
//                                     color: '#fff', 
//                                     border: 'none', 
//                                     borderRadius: '12px', 
//                                     cursor: 'pointer',
//                                     fontSize: '14px',
//                                     fontWeight: '600',
//                                     transition: 'background-color 0.2s'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#15803d'}
//                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#16a34a'}
//                             >
//                                 🖨️ Print / PDF
//                             </button>
//                             <button 
//                                 onClick={() => setSelectedInvoice(null)} 
//                                 style={{ 
//                                     padding: '10px 20px',
//                                     backgroundColor: '#ef4444', 
//                                     color: '#fff', 
//                                     border: 'none', 
//                                     borderRadius: '12px', 
//                                     cursor: 'pointer',
//                                     fontSize: '14px',
//                                     fontWeight: '600',
//                                     transition: 'background-color 0.2s'
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#dc2626'}
//                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ef4444'}
//                             >
//                                 Close
//                             </button>
//                         </div>

//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default InvoicingList;


import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const InvoicingList = () => {
    const [invoices, setInvoices] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const invoicesPerPage = 10;
    const invoiceRef = useRef();

    // Responsive Track State Hook Engine
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth < 768;

    // Fetch invoices
    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const user = JSON.parse(sessionStorage.getItem("userData"));
                if (!user?.id) return;

                const res = await axios.get(`https://cloudapi.emedhatechnologies.com/pages/api/api/invoices`, {
                    params: { user_id: user.id }
                });
                setInvoices(res.data);
            } catch (err) {
                console.error("Error fetching invoices:", err);
            }
        };
        fetchInvoices();
    }, []);

    // PDF Generation
    const handlePrintPDF = async () => {
        if (!invoiceRef.current) return;
        const canvas = await html2canvas(invoiceRef.current, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save(`Invoice_${selectedInvoice.invoice_number}.pdf`);
    };

    // Pagination logic
    const indexOfLastInvoice = currentPage * invoicesPerPage;
    const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
    const currentInvoices = invoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
    const totalPages = Math.ceil(invoices.length / invoicesPerPage);

    // Responsive metric counts computed cleanly
    const totalCount = invoices.length;
    const paidCount = invoices.filter(i => i.status === 'Paid').length;
    const sentCount = invoices.filter(i => i.status === 'Sent').length;
    const draftCount = totalCount - paidCount - sentCount;

    const getStatusStyle = (status) => {
        const baseStyle = {
            display: 'inline-block',
            padding: '4px 12px',
            borderRadius: '9999px',
            fontSize: '12px',
            fontWeight: '600',
            textAlign: 'center',
            minWidth: '70px'
        };
        switch (status) {
            case 'Paid': 
                return { ...baseStyle, backgroundColor: '#dcfce7', color: '#15803d' };
            case 'Sent': 
                return { ...baseStyle, backgroundColor: '#eff6ff', color: '#1d4ed8' };
            default:
                return { ...baseStyle, backgroundColor: '#f1f5f9', color: '#475569' };
        }
    };

    return (
        <div style={{
            // padding: isMobile ? '16px' : '24px',
            maxWidth: '1280px',
            marginLeft: 'auto',
            marginRight: 'auto',
            position: 'relative',
            minHeight: '100vh',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            backgroundColor: '#f8fafc',
            color: '#334155',
            boxSizing: 'border-box'
        }}>
            
            {/* Title Header Block */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                marginBottom: '24px'
            }}>
                <div>
                    <h1 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#0f172a', margin: '0 0 4px 0' }}>📋 Invoices</h1>
                    <p style={{ color: '#64748b', fontSize: isMobile ? '13px' : '14px', margin: 0 }}>Manage customer invoices and parameters</p>
                </div>
            </div>

            {/* Numerical Metrics Cards Grid - Fluidly drops from 4 columns to 2 columns based on screen width */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                gap: isMobile ? '10px' : '16px',
                marginBottom: '24px'
            }}>
                {[
                    { label: 'Total Invoices', value: totalCount, color: '#0f172a' },
                    { label: 'Paid', value: paidCount, color: '#16a34a' },
                    { label: 'Sent', value: sentCount, color: '#2563eb' },
                    { label: 'Pending / Draft', value: draftCount, color: '#64748b' }
                ].map((stat, idx) => (
                    <div key={idx} style={{
                        backgroundColor: '#ffffff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: isMobile ? '12px' : '16px',
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)'
                    }}>
                        <p style={{ color: '#64748b', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{stat.label}</p>
                        <h3 style={{ fontSize: isMobile ? '18px' : '24px', fontWeight: '700', color: stat.color, margin: 0 }}>{stat.value}</h3>
                    </div>
                ))}
            </div>

            {/* Table / Content Block Container Module */}
            <div style={{
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)',
                display: 'flex',
                flexDirection: 'column'
            }}>
                
                {/* 1. DESKTOP ROW TABLE VIEW: Hidden automatically on smartphone breakpoints */}
                {!isMobile && (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                            <thead>
                                <tr style={{
                                    backgroundColor: 'rgba(248, 250, 252, 0.7)',
                                    borderBottom: '1px solid #e2e8f0',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    color: '#64748b'
                                }}>
                                    <th style={{ padding: '14px 24px' }}>Invoice ID</th>
                                    <th style={{ padding: '14px 24px' }}>Customer</th>
                                    <th style={{ padding: '14px 24px' }}>Date</th>
                                    <th style={{ padding: '14px 24px', textAlign: 'right' }}>Total Amount</th>
                                    <th style={{ padding: '14px 24px', textAlign: 'center' }}>Status</th>
                                    <th style={{ padding: '14px 24px', textAlign: 'right' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentInvoices.length > 0 ? currentInvoices.map(inv => {
                                    const items = typeof inv.items === "string" ? JSON.parse(inv.items || "[]") : inv.items || [];
                                    const subtotal = items.reduce((sum, it) => sum + (it.qty * it.rate), 0);
                                    const total = subtotal * 1.18;
                                    
                                    return (
                                        <tr 
                                            key={inv.id}
                                            style={{
                                                fontSize: '14px',
                                                borderBottom: '1px solid #f1f5f9',
                                                color: '#334155',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8fafc'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                                        >
                                            <td style={{ padding: '16px 24px', fontWeight: '600', color: '#0f172a' }}>{inv.invoice_number}</td>
                                            <td style={{ padding: '16px 24px', fontWeight: '500', color: '#1e293b' }}>{inv.customer}</td>
                                            <td style={{ padding: '16px 24px', color: '#64748b' }}>{new Date(inv.date).toLocaleDateString()}</td>
                                            <td style={{ padding: '16px 24px', textAlign: 'right', fontWeight: '600', color: '#0f172a' }}>₹{total.toFixed(2)}</td>
                                            <td style={{ padding: '16px 24px', textAlign: 'center' }}>
                                                <span style={getStatusStyle(inv.status)}>{inv.status}</span>
                                            </td>
                                            <td style={{ padding: '16px 24px', textAlign: 'right' }}>
                                                <button 
                                                    onClick={() => setSelectedInvoice({ ...inv, items })}
                                                    style={{ 
                                                        background: '#2563eb', 
                                                        color: '#fff', 
                                                        border: 'none', 
                                                        padding: '6px 14px', 
                                                        borderRadius: '8px', 
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
                                                    }}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '14px' }}>No invoices found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* 2. MOBILE RESPONSIVE CARDS VIEW: Automatically replaces the structural matrix layout on smaller views */}
                {isMobile && (
                    <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#ffffff' }}>
                        {currentInvoices.length > 0 ? currentInvoices.map((inv) => {
                            const items = typeof inv.items === "string" ? JSON.parse(inv.items || "[]") : inv.items || [];
                            const subtotal = items.reduce((sum, it) => sum + (it.qty * it.rate), 0);
                            const total = subtotal * 1.18;

                            return (
                                <div key={inv.id} style={{ padding: '16px', borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: '12px', fontWeight: '700', color: '#2563eb', backgroundColor: '#eff6ff', padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace' }}>
                                            {inv.invoice_number}
                                        </span>
                                        <span style={getStatusStyle(inv.status)}>{inv.status}</span>
                                    </div>
                                    <div>
                                        <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', margin: '0 0 4px 0' }}>{inv.customer}</h4>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                            <p style={{ fontSize: '12px', color: '#94a3b8', margin: 0 }}>{new Date(inv.date).toLocaleDateString()}</p>
                                            <p style={{ fontSize: '16px', fontWeight: '700', color: '#0f172a', margin: 0 }}>₹{total.toFixed(2)}</p>
                                        </div>
                                    </div>
                                    <div style={{ paddingTop: '8px', borderTop: '1px solid #f8fafc', display: 'flex', justifyContent: 'flex-end' }}>
                                        <button 
                                            onClick={() => setSelectedInvoice({ ...inv, items })} 
                                            style={{ 
                                                width: '100%',
                                                padding: '8px 0', 
                                                fontSize: '13px', 
                                                fontWeight: '600',
                                                color: '#ffffff', 
                                                backgroundColor: '#2563eb', 
                                                border: 'none', 
                                                borderRadius: '8px', 
                                                cursor: 'pointer' 
                                            }}
                                        >
                                            View Parameters
                                        </button>
                                    </div>
                                </div>
                            );
                        }) : (
                            <div style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '14px' }}>No invoices found</div>
                        )}
                    </div>
                )}

                {/* Pagination Control Box Footer Bar - Fully adjusts flex alignments cleanly */}
                <div style={{
                    backgroundColor: 'rgba(248, 250, 252, 0.6)',
                    padding: isMobile ? '12px 16px' : '14px 24px',
                    borderTop: '1px solid #e2e8f0',
                    display: 'flex',
                    flexDirection: isMobile ? 'column-reverse' : 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: isMobile ? '12px' : '0px'
                }}>
                    <div>
                        <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>
                            Showing <span style={{ fontWeight: '600', color: '#334155' }}>{totalCount === 0 ? 0 : indexOfFirstInvoice + 1}</span> to{' '}
                            <span style={{ fontWeight: '600', color: '#334155' }}>
                                {indexOfLastInvoice > totalCount ? totalCount : indexOfLastInvoice}
                            </span>{' '}
                            of <span style={{ fontWeight: '600', color: '#334155' }}>{totalCount}</span> invoices
                        </p>
                    </div>
                    
                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center', width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'space-between' : 'flex-end' }}>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            style={{
                                padding: '6px 12px',
                                border: '1px solid #e2e8f0',
                                fontSize: '13px',
                                fontWeight: '600',
                                borderRadius: '8px',
                                color: currentPage === 1 ? '#94a3b8' : '#475569',
                                backgroundColor: '#ffffff',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Previous
                        </button>
                        
                        <span style={{ fontSize: '13px', color: '#475569', padding: '0 4px' }}>
                            Page <strong>{currentPage}</strong> of {totalPages || 1}
                        </span>

                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                padding: '6px 12px',
                                border: '1px solid #e2e8f0',
                                fontSize: '13px',
                                fontWeight: '600',
                                borderRadius: '8px',
                                color: (currentPage === totalPages || totalPages === 0) ? '#94a3b8' : '#475569',
                                backgroundColor: '#ffffff',
                                cursor: (currentPage === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {/* Sliding Overlay Side-Drawer Component Modal Layout Panel - Drops cleanly down on smartphones layout configurations */}
            {selectedInvoice && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2000,
                    display: 'flex',
                    justifyContent: isMobile ? 'center' : 'flex-end',
                    alignItems: isMobile ? 'flex-end' : 'stretch',
                    backgroundColor: 'rgba(15, 23, 42, 0.4)',
                    backdropFilter: 'blur(4px)'
                }}>
                    <div style={{
                        width: '100%',
                        maxWidth: isMobile ? '100%' : '520px',
                        height: isMobile ? '88vh' : '100%',
                        backgroundColor: '#ffffff',
                        borderTopLeftRadius: isMobile ? '24px' : '0px',
                        borderTopRightRadius: isMobile ? '24px' : '0px',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: isMobile ? '20px' : '24px',
                        boxSizing: 'border-box',
                        gap: '20px',
                        position: 'relative'
                    }}>
                        
                        {/* Target wrapper extracted into file canvas outputs safely */}
                        <div ref={invoiceRef} style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '16px', overflowY: 'auto', paddingRight: '2px' }}>
                            
                            {/* Drawer Header Block */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid #2563eb', paddingBottom: '12px' }}>
                                <div>
                                    <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0f172a', margin: 0 }}>Invoice #{selectedInvoice.invoice_number}</h3>
                                    <p style={{ color: '#94a3b8', fontSize: '12px', margin: '2px 0 0 0' }}>Invoice Parameter Details</p>
                                </div>
                            </div>

                            {/* Customer Info Grid list */}
                            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: '10px' }}>
                                {[
                                    { label: 'Customer', val: selectedInvoice.customer },
                                    { label: 'Email', val: selectedInvoice.email },
                                    { label: 'Phone', val: selectedInvoice.phone },
                                    { label: 'GSTIN', val: selectedInvoice.gstin }
                                ].map((info, idx) => (
                                    <div key={idx} style={{ border: '1px solid #f1f5f9', padding: '10px 12px', borderRadius: '12px', backgroundColor: '#f8fafc' }}>
                                        <span style={{ fontSize: '11px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', display: 'block', marginBottom: '1px' }}>{info.label}</span>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#334155', wordBreak: 'break-all' }}>{info.val || '-'}</div>
                                    </div>
                                ))}
                            </div>

                            {/* Items Responsive Table Render Engine view blocks */}
                            <div>
                                <h4 style={{ fontSize: '13px', fontWeight: '700', color: '#475569', margin: '8px 0' }}>Line Items:</h4>
                                <div style={{ border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '12px' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #e2e8f0', color: '#64748b', fontWeight: '600' }}>
                                                <th style={{ padding: '8px 12px' }}>Description</th>
                                                <th style={{ padding: '8px 4px', textAlign: 'center' }}>Qty</th>
                                                <th style={{ padding: '8px 12px', textAlign: 'right' }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(selectedInvoice.items || []).map((item, idx) => (
                                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', color: '#475569' }}>
                                                    <td style={{ padding: '8px 12px', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.description}</td>
                                                    <td style={{ padding: '8px 4px', textAlign: 'center' }}>{item.qty}</td>
                                                    <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: '500' }}>₹{(item.qty * item.rate).toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Balance Computations Stack Layout Summary */}
                            <div style={{ 
                                border: '1px solid #e2e8f0', 
                                borderRadius: '12px', 
                                display: 'flex', 
                                flexDirection: 'column', 
                                backgroundColor: '#f8fafc',
                                padding: '2px 0' 
                            }}>
                                <div style={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px' }}>
                                    <span style={{ color: '#64748b', fontWeight: '500' }}>Subtotal Valuation</span>
                                    <span style={{ fontWeight: '600', color: '#334155' }}>₹{(selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0).toFixed(2)}</span>
                                </div>
                                <div style={{ padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '8px' }}>
                                    <span style={{ color: '#64748b', fontWeight: '500' }}>GST Standard Levy (18%)</span>
                                    <span style={{ fontWeight: '600', color: '#334155' }}>₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 0.18).toFixed(2)}</span>
                                </div>
                                <div style={{ padding: '12px 16px 8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px' }}>
                                    <span style={{ color: '#0f172a', fontWeight: '700' }}>Total Document Valuation</span>
                                    <span style={{ fontSize: '16px', fontWeight: '700', color: '#2563eb' }}>₹{((selectedInvoice.items || []).reduce((a, b) => a + (b.qty * b.rate), 0) * 1.18).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Interactive Drawer Panel Action Buttons */}
                        <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '12px', display: 'flex', gap: '10px', marginBottom: isMobile ? '8px' : '0px' }}>
                            <button 
                                onClick={handlePrintPDF} 
                                style={{ 
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    padding: '12px 0',
                                    backgroundColor: '#16a34a', 
                                    color: '#fff', 
                                    border: 'none', 
                                    borderRadius: '12px', 
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '600'
                                }}
                            >
                                🖨️ Print / PDF
                            </button>
                            <button 
                                onClick={() => setSelectedInvoice(null)} 
                                style={{ 
                                    padding: '12px 20px',
                                    backgroundColor: '#ef4444', 
                                    color: '#fff', 
                                    border: 'none', 
                                    borderRadius: '12px', 
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '600'
                                }}
                            >
                                Close
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default InvoicingList;